(function () {
	const facetsMenu = () => {
		$("html.js .no_submit").click(function (e) {
			e.preventDefault();
		});
		$(
			".open_filters,.facets-menu__close,.facets__submit,.facets__reset,.form-menu__mask"
		).click(function () {
			// this legacy filter drawer is not rendered any more; without the guard every desktop
			// "Reset" link (.facets__reset) toggled the page scroll lock on
			const menu = $("#open_filters_menu");
			if (!menu.length) return;
			menu.toggleClass("show_menu");
			$("body").toggleClass("overflow-hidden", menu.hasClass("show_menu"));
		});
	};
	//const allFIlter = document.querySelector(".type-filter__all_active");
	//const qFIlter = document.querySelector(".type-filter__label_active");

	//qFIlter.addEventListener("click", function () {
	//	allFIlter.classList.add("active_opacity");
	//});
	//allFIlter.addEventListener("click", function () {
	//	allFIlter.classList.remove("active_opacity");
	//});
	document.addEventListener("DOMContentLoaded", function () {
		facetsMenu();
	});
	document.addEventListener("shopify:section:load", function () {
		facetsMenu();
	});
})();
